import React from "react";
import "./page3styles.css";
import { motion } from "framer-motion";
import page3Img1 from '../../Assets/1x/Asset 21.png';
import page3Img2 from '../../Assets/1x/Asset 22.png';
import page2Img3 from '../../Assets/1x/Asset 24.png';
import page2Img4 from '../../Assets/1x/Asset 25.png';

function Page3() {
  // detect mobile breakpoint
  //const isMobile = window.innerWidth <= 768;
  const isMobile = true;

  // A simple fade variant: initial opacity=0, animate to opacity=1.
  const fadeVariant = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 1 }
  };

  return (
    <div className="page3">
      <div className="page3-block">
        <div className="page3-block-main-text-block">
          <motion.p 
            initial={fadeVariant.initial}
            whileInView={fadeVariant.animate}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: isMobile }}
          >
            „კვირის პალიტრის“ რედაქციაში უკვე მრავალი ადამიანი
            მოვიდა კუთვნილი წერილის წასაღებად და ჩვენც თანაზიარები
            ვართ მათი დიდი ემოციების - სიხარულის და ცრემლების.
            თითოეული ადრესატი გაზეთს მადლობას უხდის ამ
            პროექტისთვის და მათი უდიდესი ნაწილი გვთხოვს,
            რომ „გზავნილი მომავალში“ გაგრძელდეს.
            ასევე, სოციალური ქსელებისა თუ სატელეფონო ზარების
            საშუალებით არანაკლებ თხოვნას ვიღებთ იმ მოქალაქეების მხრიდან, რომლებიც ახლახანს შეიტყვეს პროექტის შესახებ.
          </motion.p>
        </div>

        <div className="page3-block-first-letter-block">
          <div className="page3-block-first-letter-block-block">
            <div className="page3-block-first-letter-block-img-block">
              <motion.img 
                className="page3-img1" 
                src={page3Img1} 
                alt="Letter behind"
                initial={fadeVariant.initial}
                whileInView={fadeVariant.animate}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: isMobile }}
              />
              <motion.img 
                className="page3-img2" 
                src={page3Img2} 
                alt="Letter front"
                initial={fadeVariant.initial}
                whileInView={fadeVariant.animate}
                transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
                viewport={{ once: isMobile }}
              />
            </div>
          </div>
          <motion.p
            initial={fadeVariant.initial}
            whileInView={fadeVariant.animate}
            transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
            viewport={{ once: isMobile }}
          >
            დედის წერილი
            <br /> შვილებს
          </motion.p>
        </div>

        <div className="page3-block-second-letter-block">  
          <motion.p
            initial={fadeVariant.initial}
            whileInView={fadeVariant.animate}
            transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
            viewport={{ once: isMobile }}
          >
            ცხინვალიდან დევნილი
            <br /> საბავშვო ბაღის თანამშრომლის <br />
            წერილი
          </motion.p>
          <div className="page3-block-second-letter-block-block">
            <div className="page3-block-second-letter-block-img-block">
              <motion.img 
                className="page3-img1" 
                src={page2Img4} 
                alt="Letter behind"
                initial={fadeVariant.initial}
                whileInView={fadeVariant.animate}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: isMobile }}
              />
              <motion.img 
                className="page3-img2" 
                src={page2Img3} 
                alt="Letter front"
                initial={fadeVariant.initial}
                whileInView={fadeVariant.animate}
                transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
                viewport={{ once: isMobile }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page3;
